/**
 * Campo de ejercicio sólo valida números
 * @param {String} e 
 * @param {object} data 
 * @param {function} setData 
 */
export default function campoExclusivoNumerosEjercicio(e, setEjercicio) {
    if (!/^[0-9]*?[0-9]*$/.test(e.substring(e.length - 1))) e = e.replace(/.$/, "");
    setEjercicio(e);
}